export const environment = {
	webBase: 'https://app.healthwithheart.ai',
	appEnvironmentBaseUrl: 'https://api.alulahealth.com/health/environment',
	deeplinkURL: 'healthwithheart://',

	dislaimerUrl: 'https://corporate.healthwithheart.co.za/disclaimer-notice',
	privacyPolicy: 'https://corporate.healthwithheart.co.za/privacy-policy',
	termsOfUse: 'https://corporate.healthwithheart.co.za/terms-of-use',
	faqUrl: 'https://corporate.healthwithheart.co.za/frequently-asked-questions',
	useHelpCenter: false,
	aboutUsUrl: '#',
	contactUsUrl: '#',
	welcomeBackground: '/assets/client/hwh/background-healthwithheart.png',
	authPageLogoFallback: undefined as string | undefined,

	oneSignalAppId: '295ed024-fa05-4cd5-8c39-20ed7e60058a',
	environmentName: 'healthwithheart',
	production: true,
	apiProduction: true,
	showUatBuildBanner: false,
	includeFaceScanReportEmailMessage: true,

	countryCode: 'za',
	defaultMobileCountryCode: 'za',
	organizationId: 'ee5d2774-06f4-409c-3c2a-08de5cdda507',
	useRootAccessCodes: true,
	scanFriendAllowed: false,
	pnExternalServicesBaseUrl: undefined as string | undefined,
	enableMobileRegistation: true,
	enableWebRegistation: true,

	enableExternalLogin: false,
	enableLocalAccounts: true,

	enableEnterpriseRegistration: false,

	iosAuthRedirect: 'not-defined',
	androidAuthRedirect: 'not-defined',
	whatsappEnabled: false,
	enableRewardsPartner: true,

	androidStoreLink: 'https://play.google.com/store/apps/details?id=com.alulatechnologies.vivascore.healthwithheart',
	iosStoreLink: 'https://apps.apple.com/app/id6761112251',

	E2E_TEST_MODE: false, // Set to true when running E2E tests to enable mock API services

	defaultCulture: 'en-ZA',
	availablelanguages: [
		{ culture: 'en-ZA', text: 'English (South Africa)', dir: 'ltr' },
	],

};

